import { useContext } from 'react';
import { GenerateInvoicesReportJobContext } from './context';

export default function useGenerateInvoicesReportJobContext() {
  return useContext(GenerateInvoicesReportJobContext);
}
